import { useSwipeable } from 'react-swipeable';

import * as Styled from './side-sheet.styles';
import type { SideSheetProps } from './side-sheet.types';

export const SideSheetPrimitive = ({
  children,
  className,
  onSwipeLeft,
  ...props
}: SideSheetProps): JSX.Element => {
  const config = { delta: 40 };
  const handlers = useSwipeable({
    onSwipedLeft: () => onSwipeLeft && onSwipeLeft(),
    ...config,
  });

  return (
    <Styled.SideSheet
      className={className}
      data-qa="side-sheet"
      data-testid="side-sheet"
      data-xds="SideSheet"
      {...handlers}
      {...props}
    >
      {children}
    </Styled.SideSheet>
  );
};

SideSheetPrimitive.displayName = 'SideSheet (Primitive)';
